<template>
  <div v-if="show" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <button class="close-btn" @click="closeModal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="#999999"/>
          <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      
      <h1 class="modal-title">Get unlimited access</h1>
      
      <div class="features-list">
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="8" fill="#6C5CE7" opacity="0.2"/>
              <path d="M18 8H17L16 6H8L7 8H6C4.9 8 4 8.9 4 10V16C4 17.1 4.9 18 6 18H18C19.1 18 20 17.1 20 16V10C20 8.9 19.1 8 18 8ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15Z" fill="#6C5CE7"/>
            </svg>
          </div>
          <div class="feature-text">Unlock all blurred photos</div>
        </div>
        
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="8" fill="#6C5CE7" opacity="0.2"/>
              <path d="M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V11C9 12.66 10.34 14 12 14ZM18 11C18 14.31 15.31 17 12 17C8.69 17 6 14.31 6 11H4C4 15.42 7.58 19 12 19C16.42 19 20 15.42 20 11H18Z" fill="#6C5CE7"/>
            </svg>
          </div>
          <div class="feature-text">Voice messages from the model</div>
        </div>
        
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="8" fill="#6C5CE7" opacity="0.2"/>
              <path d="M8 5V19L19 12L8 5Z" fill="#6C5CE7"/>
            </svg>
          </div>
          <div class="feature-text">Exclusive videos</div>
        </div>
      </div>
      
      <div class="subscription-options">
        <div class="plan-card" :class="{ selected: selectedPlan === 'monthly' }" @click="selectPlan('monthly')">
          <div class="plan-info">
            <div class="plan-duration">1</div>
            <div class="plan-unit">months</div>
          </div>
          <div class="plan-divider"></div>
          <div class="plan-price">
            <span class="star-icon">⭐</span>1100
          </div>
        </div>
        
        <div class="plan-card best-value" :class="{ selected: selectedPlan === 'quarterly' }" @click="selectPlan('quarterly')">
          <div class="best-value-tag">Best value</div>
          <div class="plan-info">
            <div class="plan-duration">3</div>
            <div class="plan-unit">months</div>
          </div>
          <div class="plan-divider"></div>
          <div class="plan-price">
            <span class="star-icon">⭐</span>2700
          </div>
        </div>
        
        <div class="plan-card" :class="{ selected: selectedPlan === 'yearly' }" @click="selectPlan('yearly')">
          <div class="plan-info">
            <div class="plan-duration">12</div>
            <div class="plan-unit">months</div>
          </div>
          <div class="plan-divider"></div>
          <div class="plan-price">
            <span class="star-icon">⭐</span>9600
          </div>
        </div>
      </div>
      
      <button class="continue-btn" @click="continueSubscription" :disabled="!selectedPlan">
        Continue
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.33325 5L13.3333 10L8.33325 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedPlan: 'quarterly'
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    selectPlan(type) {
      this.selectedPlan = type
    },
    continueSubscription() {
      if (this.selectedPlan) {
        this.$emit('select', this.selectedPlan)
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  backdrop-filter: blur(10px);
}

.modal-content {
  width: 100%;
  max-width: 400px;
  background-color: white;
  color: black;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 24px 20px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;
  z-index: 10;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  margin: 10px 0 20px;
  text-align: center;
  color: black;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.feature-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-text {
  font-size: 15px;
  font-weight: 500;
  color: black;
}

.subscription-options {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 24px;
}

.plan-card {
  flex: 1;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.plan-card.selected {
  border-color: #6C5CE7;
  border-width: 2px;
}

.plan-card.best-value {
  background-color: #6C5CE7;
  border: none;
  position: relative;
}

.best-value-tag {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  text-align: center;
  background-color: transparent;
  color: white;
  font-size: 13px;
  font-weight: 600;
  padding: 2px 0;
  z-index: 2;
}

.plan-info {
  text-align: center;
  padding: 8px 0;
}

.plan-duration {
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 3px;
  color: black;
}

.plan-card.best-value .plan-duration,
.plan-card.best-value .plan-unit,
.plan-card.best-value .plan-price {
  color: white;
}

.plan-unit {
  font-size: 14px;
  color: #666666;
}

.plan-divider {
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
}

.plan-card.best-value .plan-divider {
  background-color: rgba(255, 255, 255, 0.3);
}

.plan-price {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: black;
  padding: 8px 0;
}

.star-icon {
  margin-right: 4px;
  font-size: 16px;
}

.continue-btn {
  width: 100%;
  padding: 14px;
  background-color: #E575A8;
  color: white;
  border: none;
  border-radius: 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background-color 0.2s ease;
  margin-top: 10px;
}

.continue-btn:hover {
  background-color: #D65A9A;
}

.continue-btn:disabled {
  background-color: #444;
  cursor: not-allowed;
}

/* Mobile styles to match the second image */
@media (max-width: 480px) {
  .modal-overlay {
    background-color: rgba(0, 0, 0, 0.7);
    align-items: flex-end;
  }
  
  .modal-content {
    max-height: 80%;
    border-radius: 24px 24px 0 0;
    padding-top: 24px;
  }
  
  .close-btn {
    top: 16px;
    right: 16px;
  }
  
  .modal-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .feature-text {
    font-size: 15px;
  }
  
  .subscription-options {
    margin-bottom: 20px;
    gap: 10px;
  }
  
  .plan-card {
    height: auto;
    padding: 15px 8px;
  }
  
  .plan-duration {
    font-size: 36px;
    margin-top: 0;
  }
  
  .plan-unit {
    font-size: 14px;
    margin-bottom: 6px;
  }
  
  .continue-btn {
    margin: 10px 0 20px;
    padding: 16px;
    font-size: 16px;
  }
}

/* Desktop styles to match the second image */
@media (min-width: 481px) {
  .subscription-options {
    flex-direction: row;
    gap: 10px;
    margin-top: 20px;
  }

  .plan-card {
    flex: 1;
    height: auto;
    padding: 16px 8px;
  }
  
  .best-value-tag {
    padding: 2px 0;
    top: 8px;
  }
  
  .plan-card.best-value {
    margin-top: 0;
  }
}
</style> 